import { render, staticRenderFns } from "./page_build.vue?vue&type=template&id=6584273e&scoped=true"
import script from "./page_build.vue?vue&type=script&lang=js"
export * from "./page_build.vue?vue&type=script&lang=js"
import style0 from "./page_build.vue?vue&type=style&index=0&id=6584273e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6584273e",
  null
  
)

export default component.exports